export default __webpack_public_path__ + "static/media/kyc-help.53803965.svg";